import { h } from './dom';
import { getState, setState, subscribe, type Tab } from './state';
import { sync } from './data';

const TABS: { id: Tab; label: string; icon: string }[] = [
  { id: 'mappa', label: 'Mappa', icon: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 4 3 6v14l6-2 6 2 6-2V4l-6 2-6-2Zm0 2.2 6 2v11.6l-6-2V6.2Z"/></svg>' },
  { id: 'posto', label: 'Sul posto', icon: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm3.5 4.5-5 2-2 5 5-2 2-5Z"/></svg>' },
  { id: 'misure', label: 'Misure', icon: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 20h16v-2H4v2Zm1-4h3V9H5v7Zm5.5 0h3V4h-3v12Zm5.5 0h3v-5h-3v5Z"/></svg>' },
];

export function mountShell(root: HTMLElement) {
  const outlets = Object.fromEntries(TABS.map(t => [t.id, h('main', { class: `view view-${t.id}`, id: `view-${t.id}` })])) as Record<Tab, HTMLElement>;
  const banner = h('div', { class: 'banner', hidden: true });
  const nav = h('nav', { class: 'tabbar', 'aria-label': 'Sezioni' });

  function render() {
    const st = getState();
    for (const t of TABS) outlets[t.id].hidden = st.tab !== t.id;
    nav.replaceChildren(
      ...TABS.map(t => {
        const b = h('button', { class: 'tab' + (st.tab === t.id ? ' on' : ''), 'aria-current': st.tab === t.id ? 'page' : undefined, onclick: () => setState({ tab: t.id }) });
        b.innerHTML = t.icon;
        b.append(h('span', {}, t.label));
        if (t.id === 'misure' && st.pending.length) b.append(h('span', { class: 'count' }, String(st.pending.length)));
        return b;
      }),
    );
    if (st.authExpired) {
      banner.hidden = false;
      banner.replaceChildren('Sessione scaduta. ', h('a', { href: '/', onclick: () => location.reload() }, 'Accedi di nuovo per sincronizzare'));
    } else if (st.offline) {
      banner.hidden = false;
      banner.replaceChildren('Sei offline: le misure restano sul telefono e partono appena torna la rete.');
    } else banner.hidden = true;
  }

  root.append(banner, ...Object.values(outlets), nav);
  subscribe((s, p) => {
    if (s.tab !== p.tab || s.pending !== p.pending || s.authExpired !== p.authExpired || s.offline !== p.offline) render();
  });
  render();

  window.addEventListener('online', () => { setState({ offline: false }); void sync(); });
  window.addEventListener('offline', () => setState({ offline: true }));
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') void sync(); });

  return { outlet: (t: Tab) => outlets[t], show: (t: Tab) => setState({ tab: t }) };
}
